import { render, staticRenderFns } from "./openReview.vue?vue&type=template&id=fd126ffc&scoped=true&"
import script from "./openReview.vue?vue&type=script&lang=js&"
export * from "./openReview.vue?vue&type=script&lang=js&"
import style0 from "./openReview.vue?vue&type=style&index=0&id=fd126ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd126ffc",
  null
  
)

export default component.exports